var selector_quantity = '.bullet-holder .shop_quantity-circle';

$(selector_quantity).on('click', function(e){
  e.preventDefault();
    $(selector_quantity).removeClass('active');
    $(this).addClass('active');
   var qty =  $(this).text();

   var form =  $(this).closest('form');
   form.find('input[name="quantity"]').val(parseInt(qty));
 

});



function closeCart(e,el){
    e.preventDefault();
    $('body').removeClass('cartShow');
}

$(document).on("click",".product-cart-overlay",function(e) {
  e.preventDefault();
  $('body').removeClass('cartShow');
});


$(document).on("click",".cart-trigger ",function(e) {
    e.preventDefault();
    $('body').addClass('cartShow');
  });



  $( ".single-product__atc").on("click", function (e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.main-product-form').serialize(),
          success: function(data) {
             get_cart_details();
             $('body').addClass('cartShow');
          },
          error: 'addToCartFail'
      });
      
  });

  
  function get_cart_details(){
    fetch("?section_id=cart-drawer")
      .then((response) => response.text())
      .then((cartData) => {

        var cart_html = $(cartData);
        var cart_items = $(".product-cart-wrap", cart_html);
        $(".product-cart-wrap").replaceWith(cart_items);

      });
  
      fetch("?section_id=header")
      .then((response) => response.text())
      .then((headerData) => {
        var header_html = $(headerData);

        var cart_count = $(".navbar_basket", header_html);
        $(".navbar_basket").replaceWith(cart_count);

      });
      
  
  };


  function change_qty($input){
    var variant_id= $($input).attr("data-id");
    var quantity= $($input).val();          
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {               
        get_cart_details();
      }
    });
  };



  function increaseItem(e, el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    $input.value = ('0' + value).slice(-2);            
    change_qty($input);
  }
  
  function decreaseItem(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = ('0' + value).slice(-2);         
        change_qty($input);
    }
  }


  function itemRemove(e , el){
    e.preventDefault();
    var variant_id = $(el).attr('data-id');
    
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        get_cart_details();
      }
    });
  }




  $('.shop_btn-text').removeAttr('data-price-mutation-watcher');
  var selector = '.shop_purchase';

$('.shop_purchase-info, .shop_purchase-info-bot').on('click', function(){
    $(selector).removeClass('active');
    $(this).parent().parent().addClass('active');

    var type = $(this).parent().parent().data('value');

    $('.shop_btn-text').removeAttr('data-price-mutation-watcher');

    if(type === "autodeliver"){
        var selling_id = $(this).parent().parent().attr('data-selling-id');
        var subscription_price = $(this).parent().parent().attr('data-subscription-price');

        console.log("tress", subscription_price);

         $('.shop_plan').find('input[name="selling_plan"]').val(selling_id);
          $('.product-pricee').text(subscription_price);

    }else{
        var ontime_price = $(this).parent().parent().attr('data-ontime-price');
         $('.shop_plan').find('input[name="selling_plan"]').val('');
         $('.product-pricee').text(ontime_price);
         console.log("tress", ontime_price);
    }
});



// var page_title = $('.shopify-policy__title h1').text();
// var lastword = page_title.split(" ").pop();
// console.log(lastword);
// lastword.replace(/St$/, '<strong>'+lastword+'</strong>');
var text = $('.shopify-policy__title h1').text().trim().split(" ");
  var last = text.pop();
  $('.shopify-policy__title h1').html(text.join(" ") + (text.length > 0 ? " <span class='Lastword'>" + last + "</span>" : last));


  $('.shop-control-layout').click(function(){
    var image_path = $(this).attr('data-image');
    $('.shop-left img').attr('src', image_path);
  });

  $('.mobile-thumb').click(function(){
    var image_path = $(this).attr('data-image');
    $('.shop-left img').attr('src', image_path);
  });

  $('.variant').click(function(){
    var one_time_price = $(this).attr('one-time-price');
    var subscription_price = $(this).attr('subscription-price');
    var availability = $(this).attr('available');
    $('.plan-one-time .shop_purchase-price').text(one_time_price);
    $('.plan-subscription .shop_purchase-price').text(subscription_price);

    $('.plan-one-time').attr('data-ontime-price', one_time_price);
    $('.plan-subscription').attr('data-subscription-price', subscription_price);

    var plan_type = $('.shop_purchase.active').attr('data-value');
    if(plan_type == 'onetime'){
      var btn_price = $('.shop_purchase.active').attr('data-ontime-price');
    }else{
      var btn_price = $('.shop_purchase.active').attr('data-subscription-price');
    }
    $('.product-pricee').text(btn_price);
    if(availability == 'false'){
      $('.shop-btn').addClass('btn_disabled');
    }else{
      $('.shop-btn').removeClass('btn_disabled');
    }
  });

  $('.custom-dropdown-stat').click(function(e){
    e.stopPropagation();
    $(this).next().slideToggle();
  });

  $(document).click(function(){
    $('.custom-dropdown__list-wrap').slideUp();
  });

  $('.custom-dropdown__list').click(function(){
    var data_plan_id = $(this).attr('data-plan');
    var data_plan_name = $(this).text();
    $('.plan-subscription').attr('data-selling-id', data_plan_id);
    $('.my-selling-plan').val(data_plan_id);
    $('.custom-dropdown-stat span').text(data_plan_name);
    $('.plan-subscription').attr('data-selling-id', data_plan_id);
  });